var _ShowPasswordElement_instances, _ShowPasswordElement_button, _ShowPasswordElement_input, _ShowPasswordElement_buttonState, _ShowPasswordElement_showPassword;
import { __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { customElement } from "./custom-element";
/**
 * This element is used to show and hide a password input's value along with a status icon.
 *
 * Status icons are optional and should contain the `data-show-password-status` attribute
 * and use the `hidden` class to set their default state.
 *
 * @example
 * ```html
 * <show-password>
 *   <input type="password">
 *   <button type="button">
 *     Show password
 *     <span>
 *       <svg data-show-password-status>...</svg>
 *       <svg class="hidden" data-show-password-status>...</svg>
 *     </span>
 *   </button>
 * </show-password>
 * ```
 */
let ShowPasswordElement = class ShowPasswordElement extends HTMLElement {
    constructor() {
        super(...arguments);
        _ShowPasswordElement_instances.add(this);
        _ShowPasswordElement_button.set(this, null);
        _ShowPasswordElement_input.set(this, null);
    }
    connectedCallback() {
        __classPrivateFieldSet(this, _ShowPasswordElement_button, this.querySelector("button"), "f");
        if (!__classPrivateFieldGet(this, _ShowPasswordElement_button, "f")) {
            console.warn("Show password button not found");
            return;
        }
        __classPrivateFieldSet(this, _ShowPasswordElement_input, this.querySelector("input"), "f");
        if (!__classPrivateFieldGet(this, _ShowPasswordElement_input, "f")) {
            console.warn("Password input not found");
            return;
        }
        // Sets our default state in case the markup didn't already set it
        __classPrivateFieldGet(this, _ShowPasswordElement_instances, "m", _ShowPasswordElement_buttonState).call(this, __classPrivateFieldGet(this, _ShowPasswordElement_input, "f").getAttribute("type") === "text");
        __classPrivateFieldGet(this, _ShowPasswordElement_button, "f").addEventListener("click", this);
    }
    disconnectedCallback() {
        var _a;
        (_a = __classPrivateFieldGet(this, _ShowPasswordElement_button, "f")) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", this);
    }
    handleEvent(event) {
        if (event.type === "click") {
            __classPrivateFieldGet(this, _ShowPasswordElement_instances, "m", _ShowPasswordElement_showPassword).call(this);
        }
    }
};
_ShowPasswordElement_button = new WeakMap();
_ShowPasswordElement_input = new WeakMap();
_ShowPasswordElement_instances = new WeakSet();
_ShowPasswordElement_buttonState = function _ShowPasswordElement_buttonState(state) {
    var _a;
    (_a = __classPrivateFieldGet(this, _ShowPasswordElement_button, "f")) === null || _a === void 0 ? void 0 : _a.setAttribute("aria-pressed", state ? "true" : "false");
};
_ShowPasswordElement_showPassword = function _ShowPasswordElement_showPassword() {
    var _a, _b, _c;
    const type = ((_a = __classPrivateFieldGet(this, _ShowPasswordElement_input, "f")) === null || _a === void 0 ? void 0 : _a.getAttribute("type")) === "password" ? "text" : "password";
    (_b = __classPrivateFieldGet(this, _ShowPasswordElement_input, "f")) === null || _b === void 0 ? void 0 : _b.setAttribute("type", type);
    __classPrivateFieldGet(this, _ShowPasswordElement_instances, "m", _ShowPasswordElement_buttonState).call(this, type === "text");
    for (const icon of this.querySelectorAll("[data-show-password-status]")) {
        icon.classList.toggle("hidden");
    }
    (_c = __classPrivateFieldGet(this, _ShowPasswordElement_input, "f")) === null || _c === void 0 ? void 0 : _c.focus();
};
ShowPasswordElement = __decorate([
    customElement
], ShowPasswordElement);
export { ShowPasswordElement };
